module.exports = __webpack_public_path__ + "img/22010____-38.prt.f68ea52e.jpg";